import { Injectable } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  comparison(
    categories: string[],
    series: { name: string; data: number[] }[]
  ): ApexOptions {

    return {

      series,

      chart: {
        type: 'line',
        height: 340,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },

      stroke: {
        curve: 'smooth',
        width: 3
      },

      dataLabels: {
        enabled: false
      },

      markers: {
        size: 4
      },

      grid: {
        strokeDashArray: 4
      },

      xaxis: {
        categories
      },

      legend: {
        position: 'top'
      },

      tooltip: {
        shared: true,
        intersect: false
      }

    };

  }

  donut(
    labels: string[],
    values: number[]
  ): ApexOptions {

    return {

      series: values,

      labels,

      chart: {
        type: 'donut',
        height: 120
      },

      legend: {
        position: 'bottom'
      },

      dataLabels: {
        enabled: true
      }

    };

  }

}